import AboutImage from '../../assets/trixjoyeuxportrait2.png'
import CV from '../../assets/cv.pdf'
import {HiDownload} from 'react-icons/hi'
import data from './data'
import Card from '../../components/Card'
import './about.css'

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
        <div className="container about__container">
            <div className="about__left">
                <div className="about__portrait">
                    <img src={AboutImage} alt="About Image" />
                </div>
            </div>
            <div className="about__right">
                <h2>À propos de moi</h2>
                <div className="about__cards">
                    {
                        data.map(item => (
                            <Card key={item.id} className="about__card">
                                <span className='about__card-icon'>{item.icon}</span>
                                <h5>{item.title}</h5>
                                <small>{item.desc}</small>
                            </Card>
                        ))
                    }
                </div>
                <p>
              Je suis pationné des technologie Web, je cherche à développer au maximum mes compétences dans le WEB3 et la technologie blockchain.
            </p>
            <p>
              React, Photoshop et Solidity serons mes meilleurs amis !
            </p>
                <a href={CV} download className='btn primary'>Télécharger le CV <HiDownload/></a>
            </div>
        </div>
    </section>
  )
}

export default About